import React from "react";
import { Translate } from "components/common/Translate/Translate";
import { FAQScaffold } from "components/features/CompressorCommon/FAQScaffold";
import { ImageConverterPageTemplateInterface } from "@/templates/ImageConverterPageTemplateInterface";

const ImageConverterSection10FAQ = ({
    template,
    variables,
}: {
    template: ImageConverterPageTemplateInterface;
    variables?: Record<any, any>;
}) => {
    return (
        <FAQScaffold
            faqAsList={template.section10.items}
            sectionTitle={<Translate keyName={template.section10.title} variables={variables} />}
            sectionSubTitle={<Translate keyName={template.section10.subTitle} variables={variables} />}
            variables={variables}
        />
    );
};

export default ImageConverterSection10FAQ;
